import RX = require('reactxp');
import App from './App';

RX.App.initialize(false, false);
RX.UserInterface.registerRootView('wdigfc', () => App);
RX.UserInterface.setMainView(<App />);



// WEBPACK FOOTER //
// ./src/index.tsx